{
  "source": "Development UvSync: pmxf.PMXF joined to rtg.vwProductSKUOnly (TYPE P), matching Intranet.GET_SKU_INFO",
  "capturedOn": "2026-10-15",
  "division": "SE",
  "currency": "USD",
  "unit": "ordered SKU unit",
  "firstCostBySku": {
    "12612241": 159,
    "18902141": 33,
    "18902153": 33,
    "18902165": 33,
    "18902177": 33,
    "18902189": 33,
    "18902191": 33,
    "18902204": 99,
    "18902216": 33,
    "18903143": 50,
    "18903155": 43,
    "75510125": 42,
    "75511709": 44,
    "75512004": 40,
    "75512345": 36,
    "75512369": 36,
    "75512371": 36,
    "75512408": 36,
    "75512509": 32,
    "75607699": 40,
    "75607992": 42,
    "75610127": 39,
    "75610444": 39,
    "75610646": 39,
    "75611701": 37,
    "75612006": 36,
    "75612347": 36,
    "75612361": 36,
    "75612373": 36,
    "75612400": 36,
    "75612501": 32,
    "75612816": 79,
    "75911012": 77,
    "75911024": 62,
    "75912230": 77,
    "77110129": 232,
    "77110446": 290,
    "77110648": 290,
    "77112008": 208,
    "77112349": 183,
    "77112363": 183,
    "77112375": 201,
    "77112402": 193,
    "77112503": 162,
    "77112818": 278,
    "77210121": 171,
    "77210448": 211,
    "77210640": 211,
    "77212000": 161,
    "77212341": 141,
    "77212365": 141,
    "77212377": 152,
    "77212404": 145,
    "77212505": 125,
    "77212810": 197,
    "77300463": 74,
    "77301251": 108,
    "77301504": 95,
    "77301605": 88,
    "77301706": 88,
    "77307695": 77,
    "77307998": 82,
    "77310123": 95,
    "77310440": 115,
    "77310642": 115,
    "77312002": 90,
    "77312379": 87,
    "77312406": 82,
    "77312507": 71,
    "77312812": 106,
    "77400465": 56,
    "77401253": 61,
    "77401506": 55,
    "77401708": 48,
    "77410000": 58,
    "77410442": 61,
    "77410644": 61,
    "77412004": 51,
    "77412345": 51,
    "77412369": 51,
    "77412371": 52,
    "77412408": 50,
    "77412509": 45,
    "77412814": 51,
    "77510127": 125,
    "77510444": 125,
    "77510646": 125,
    "77511701": 165,
    "77512006": 112,
    "77512347": 102,
    "77512361": 102,
    "77512373": 110,
    "77512400": 104,
    "77512501": 89,
    "77512816": 136,
    "77610446": 201,
    "77610648": 201,
    "77710448": 110,
    "77710640": 110,
    "77810440": 193,
    "77810642": 193,
    "77812343": 81,
    "77812367": 81,
    "78300363": 85,
    "78300464": 85,
    "78312813": 254,
    "78401266": 133,
    "78401709": 108,
    "78811215": 29,
    "78811316": 29,
    "78811518": 29,
    "78812902": 23,
    "78911217": 63,
    "78911318": 61,
    "78911510": 60,
    "93302063": 87,
    "93302075": 87,
    "93302087": 87,
    "93302099": 87,
    "93302102": 86,
    "93302114": 77
  }
}
